// Shared constants/helpers for the Biblio module.

// biblio_status_deploy meanings (mirrors publishers semantics).
export const DEPLOY_STATUS_LABELS = {
    0: 'Sin desplegar',
    1: 'Desplegada',
    2: 'En despliegue',
};

export function deployStatusLabel(value) {
    return DEPLOY_STATUS_LABELS[value] !== undefined ? DEPLOY_STATUS_LABELS[value] : '—';
}

export const LANGUAGE_OPTIONS = [
    { value: 'es', label: 'Español' },
    { value: 'en', label: 'Inglés' },
];

// -1 = ilimitado.
export const UNLIMITED = -1;

export function formatLimit(value) {
    if (value === null || value === undefined) return '—';
    return Number(value) < 0 ? 'Ilimitado' : String(value);
}

// URL Ink de la tienda: se deriva siempre del prefijo + dominio base.
export function storeInkUrl(prefix) {
    if (!prefix) return '';
    return `${String(prefix).toLowerCase()}.biblio.digital`;
}

export function formatMoney(amount, currency) {
    const n = Number(amount || 0);
    try {
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: currency || 'MXN',
            maximumFractionDigits: 2,
        }).format(n);
    } catch (e) {
        return `${n} ${currency || ''}`.trim();
    }
}

export function formatDate(value) {
    if (!value) return '—';
    return value;
}
